<template>
  <div class="statistics">
    <!-- <hr /> -->
    <div class="statistics__range">
      <b-form-checkbox size="sm" v-model="includeRequote" class="mr-5"
        >Include Requote
      </b-form-checkbox>
      <b-form-datepicker
        class="statistics__range--date"
        v-model="firstDate"
        placeholder="from"
        size="sm"
      ></b-form-datepicker>
      <b-form-datepicker
        class="statistics__range--date"
        v-model="secondDate"
        placeholder="to"
        size="sm"
      ></b-form-datepicker>
      <b-overlay
        :show="gettingStatistics"
        rounded
        opacity="0.6"
        spinner-small
        class="d-inline-block"
      >
        <b-button
          class="statistics__range--button-send"
          @click="sendDates"
          :disabled="gettingStatistics"
          size="sm"
          ><i class="fas fa-paper-plane"></i> Send</b-button
        >
      </b-overlay>
      <b-overlay
        :show="downloadingReport"
        rounded
        opacity="0.6"
        spinner-small
        class="d-inline-block"
      >
        <b-button
          @click="downloadReport"
          :disabled="downloadingReport"
          class="statistics__range--button-report"
          size="sm"
          >Report
          <b-icon icon="cloud-download"></b-icon>
        </b-button>
      </b-overlay>
    </div>

    <div class="statistics__content">
      <b-table
        class="statistics__content--table container"
        head-variant="light"
        stacked="md"
        small
        hover
        :items="items"
      >
        <template v-slot:thead-top="data">
          <b-tr v-bind:key="data.columns">
            <b-th variant="dark" colspan="5">
              <h4 style="color: white">
                <b>Total: {{ totalQuotes }}</b>
              </h4>
            </b-th>
          </b-tr>
        </template>
      </b-table>
      <Chart
        :key="keyChart"
        type="horizontalBar"
        :data="usersData"
        class="statistics__content--chart"
      />
    </div>
    <hr />
  </div>
</template>

<script>
import Chart from "primevue/chart";
import statisticsColors from "@/utils/statisticsColors";

export default {
  name: "Statistics",
  components: {
    Chart
  },
  props: {
    data: Object
  },
  data() {
    return {
      items: [],
      usersData: {
        labels: [],
        datasets: [
          {
            label: "Sent",
            backgroundColor: [],
            data: []
          }
        ]
      },
      firstDate: null,
      secondDate: null,
      gettingStatistics: false,
      keyChart: 0,
      totalQuotes: 0,
      downloadingReport: false,
      includeRequote: true
    };
  },
  created() {
    for (let user in this.data) {
      this.totalQuotes += this.data[user];
      let userStatistics = {};
      userStatistics.username = user;
      userStatistics.sent = this.data[user];
      this.usersData.labels.push(user);
      this.usersData.datasets[0].data.push(userStatistics.sent);
      this.usersData.datasets[0].backgroundColor = statisticsColors;
      this.items.push(userStatistics);
    }
  },
  mounted() {
    let max = -1;
    let usernameMax = undefined;
    for (let userStatistics of this.items) {
      if (userStatistics.sent > max) {
        usernameMax = userStatistics.username;
        max = userStatistics.sent;
      }
    }
    for (let i in this.items) {
      if (this.items[i].username == usernameMax) {
        this.items[i]._rowVariant = "info";
      }
    }
  },
  methods: {
    getMax() {
      let max = -1;
      let usernameMax = undefined;
      for (let userStatistics of this.items) {
        if (userStatistics.sent > max) {
          usernameMax = userStatistics.username;
          max = userStatistics.sent;
        }
      }
      for (let i in this.items) {
        if (this.items[i].username == usernameMax) {
          this.items[i]._rowVariant = "info";
        }
      }
    },
    async sendDates() {
      let start = "T00:00:00";
      let end = "T23:59:59";
      if (
        this.firstDate != null &&
        this.firstDate != "" &&
        this.secondDate != null &&
        this.secondDate != ""
      ) {
        this.gettingStatistics = true;
        this.usersData.labels = [];
        this.usersData.datasets[0].data = [];
        this.items = [];
        let info = {};
        info.id = this.$store.getters[
          "login/showUserLoggedIn"
        ][0].department.id;
        info.firstDate = this.firstDate + start;
        info.secondDate = this.secondDate + end;
        info.includeRequote = this.includeRequote;
        info.responseType = "";
        let response = await this.$store.dispatch(
          "usersManagement/allocate/getStatisticsByDate",
          info
        );
        this.totalQuotes = 0;
        for (let user in response.data) {
          this.totalQuotes += response.data[user];
          let userStatistics = {};
          userStatistics.username = user;
          userStatistics.sent = response.data[user];
          this.usersData.labels.push(user);
          this.usersData.datasets[0].data.push(userStatistics.sent);
          this.usersData.datasets[0].backgroundColor = statisticsColors;
          this.items.push(userStatistics);
        }
        this.keyChart += 1;
        this.getMax();
        this.gettingStatistics = false;
      } else {
        this.swal({
          title: "Warning!",
          text: "Some date is missing.",
          icon: "warning",
          button: "OK"
        });
      }
    },
    async downloadReport() {
      this.downloadingReport = true;
      let info = {};
      if (this.firstDate && this.secondDate) {
        info.id = this.$store.getters[
          "login/showUserLoggedIn"
        ][0].department.id;
        info.firstDate = this.firstDate + "T00:00:00";
        info.secondDate = this.secondDate + "T23:59:59";
        info.includeRequote = this.includeRequote;
        info.responseType = "&response_type=csv";
        let response = await this.$store.dispatch(
          "usersManagement/allocate/getStatisticsByDate",
          info
        );
        if (response.status == 200) {
          let uriContent =
            "data:application/csv," + encodeURIComponent(response.data);
          let link = document.createElement("a");
          link.setAttribute("href", uriContent);
          link.setAttribute(
            "download",
            `Assistant-report${this.firstDate}-${this.secondDate}.csv`
          );
          link.click();
        }
      } else {
        this.swal({
          title: "Warning!",
          text: "Some date is missing.",
          icon: "warning",
          button: "OK"
        });
      }
      this.downloadingReport = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.statistics {
  padding: 10px;
  &__range {
    margin: 30px 0px;
    @include flex-wrap(flex-end);
    &--date {
      width: 200px;
      text-align: left;
      margin-right: $margin-most-used;
    }
    &--button-send {
      @include secondary-button;
    }
    &--button-report {
      @include secondary-button;
      margin: 10px;
    }
  }
  &__content {
    @include flex-wrap(center);
    &--table {
      max-width: 20%;
      margin-top: $margin-most-used;
      @include box-shadow;
    }
    &--chart {
      width: 70%;
    }
  }
}

@media (max-width: 1100px) {
  .statistics__content {
    @include flex-wrap(column);
    &--table {
      max-width: 90%;
    }
    &--chart {
      width: 90%;
    }
  }
}

.table .thead-light th {
  color: $color-light;
  background-color: $color-background-dark;
  border: none;
  border-radius: $margin-most-used $margin-most-used 0px 0px;
}

.b-table {
  border-radius: $margin-most-used;
}
</style>
